import { memo } from 'react';
import {
  Circle as _Circle,
  Mask as _Mask,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg,
} from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      height={size}
      width={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Circle cx="7.77273" cy="7.84499" r="7.77273" fill={color} />
      <_Path
        d="M6.21875 4.42578L10.8248 7.41972L6.21875 10.4137V4.42578Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </_Svg>
  );
};
Icon.displayName = 'PlaySolidRegular';
const PlaySolidRegular = memo(themed(Icon));
export { PlaySolidRegular };
